// localStorage helpers for the user's last-selected workspace. Lives apart
// from `workspace-context.tsx` so route loaders can read the stored id
// during the boot/layout redirect guards (before the WorkspaceProvider
// mounts) without dragging in the React-bound context module.
//
// Storage shape: `{ "id": "0199c2f4-…" }` JSON-encoded under STORAGE_KEY.
// The URL is the tenancy source of truth (see workspace-context.tsx) — this
// value is only ever a *fallback* for `/` and for an invalid `:workspaceId` in
// the URL.

const STORAGE_KEY = "selectedWorkspace";

/**
 * Read the user's last-selected workspace id from localStorage. Returns null
 * when nothing is stored or localStorage is unavailable (private browsing,
 * quota, SSR-less test environments).
 */
export function readStoredId(): string | null {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) return null;
        return (JSON.parse(stored) as { id?: string }).id ?? null;
    } catch {
        return null;
    }
}

export function persistId(id: string): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ id }));
    } catch {
        /* ignore quota / privacy errors */
    }
}
